import ClubDealsLogo from 'oldAssets/images/static_pages/club_deals/banner_icon.svg';

import CheckMarker from 'oldAssets/images/icons/check-green.svg';

import HowItWorksImage from 'oldAssets/images/static_pages/club_deals/how_it_works.webp';
import YourAdvantagesImage from 'oldAssets/images/static_pages/club_deals/your_advantages.webp';
const howItWorksSectionImages = [HowItWorksImage, YourAdvantagesImage];

import WhyInvestInClubDealsSectionImage from 'oldAssets/images/static_pages/club_deals/why_invest_in_club_deals.webp';

import StrategiesPhoto from 'oldAssets/images/static_pages/club_deals/strategies_photo.webp';

import CardImage01 from 'oldAssets/images/static_pages/club_deals/strategies_horizontal_card1.webp';
import CardImage02 from 'oldAssets/images/static_pages/club_deals/strategies_horizontal_card2.webp';
import CardImage03 from 'oldAssets/images/static_pages/club_deals/strategies_horizontal_card3.webp';
const strategiesCardImages = [CardImage01, CardImage02, CardImage03];


import VerticalCardImage01 from 'oldAssets/images/static_pages/club_deals/current_opportunities_vertical_card1.webp';
import VerticalCardImage02 from 'oldAssets/images/static_pages/club_deals/current_opportunities_vertical_card2.webp';
import VerticalCardImage03 from 'oldAssets/images/static_pages/club_deals/current_opportunities_vertical_card3.webp';
const currentOpportunitiesCardImages = [VerticalCardImage01, VerticalCardImage02, VerticalCardImage03];

export {
  ClubDealsLogo,
  CheckMarker,
  howItWorksSectionImages,
  WhyInvestInClubDealsSectionImage,
  StrategiesPhoto,
  strategiesCardImages,
  currentOpportunitiesCardImages
}
